import Sifter from 'sifter';

export function searchForMessage(searchString, data = [], options = {
  respect_word_boundaries: true, filter: true, fields: ['name', 'threadMessages'],
}) {
  ;
  var sifter = new Sifter(data);
  const { items } = sifter.search(searchString, options);
  return items.map(({ id }) => data[id]);
}